import './ContainerSuggestions.css';

const ContainerSuggestions = ({ children }) => (
  <div className="container-password-suggestions">{children}</div>
);

export default ContainerSuggestions;
